import React from "react";
import LogoResized from "../../themes/LogoResized";
import "../../css/terms.css";

const TermsConditions = () => {
    return (
        <div className="terms-page">
            {/* Logo */}
            <div className="terms-logo">
                <LogoResized width={250} height={180} />
            </div>

            <h1>Terms & Conditions</h1>
            <p className="effective-date">Effective Date: January 13, 2026</p>

            <p>
                Welcome to ServSpace AI. These Terms & Conditions explain how our platform
                works and outline the responsibilities of everyone using it. By accessing
                or using ServSpace AI, you acknowledge and agree to these terms.
            </p>

            <h2>1. Our Role</h2>
            <p>
                ServSpace AI is an AI-assisted platform designed to help connect users
                with freelancers and businesses. We act solely as a facilitator and
                introduction service. We do not provide the services offered by
                freelancers or businesses listed on the platform.
            </p>

            <h2>2. AI-Assisted Recommendations</h2>
            <p>
                Our platform uses artificial intelligence, including third-party AI
                services such as Anthropic’s Claude, to help match users with relevant
                freelancers or businesses. These recommendations are generated
                algorithmically and are provided for convenience only.
            </p>
            <p>
                We do not guarantee accuracy, quality, availability, pricing, or
                outcomes of any recommendation. AI systems may make errors or produce
                incomplete results.
            </p>

            <h2>3. User & Business Information</h2>
            <p>
                Users, freelancers, and businesses are responsible for ensuring that
                any information they provide is accurate, lawful, and up to date.
                ServSpace AI does not verify credentials, licenses, insurance, or
                qualifications unless explicitly stated.
            </p>

            <h2>4. Third-Party Services</h2>
            <p>
                We may use third-party services including but not limited to AI APIs,
                analytics tools, and mapping services (such as Google Maps) to improve
                functionality. These services operate under their own terms and
                policies.
            </p>

            <h2>5. Interactions Outside the Platform</h2>
            <p>
                Any communication, agreement, transaction, or interaction that occurs
                between users and freelancers or businesses—whether online or
                offline—is solely between those parties.
            </p>
            <p>
                ServSpace AI is not responsible for disputes, damages, losses, injuries,
                delays, misrepresentations, or outcomes resulting from such
                interactions.
            </p>

            <h2>6. Payments & Agreements</h2>
            <p>
                Unless otherwise stated, ServSpace AI is not a party to any agreement,
                contract, or payment arrangement between users and service providers.
            </p>

            <h2>7. Acceptable Use</h2>
            <p>
                You agree not to misuse the platform, submit false or misleading
                information, attempt to reverse engineer our systems, or engage in any
                unlawful or abusive behavior.
            </p>

            <h2>8. Limitation of Liability</h2>
            <p>
                To the maximum extent permitted by law, ServSpace AI shall not be liable
                for any indirect, incidental, consequential, or special damages arising
                from your use of the platform.
            </p>

            <h2>9. Termination</h2>
            <p>
                We reserve the right to suspend or terminate access to the platform at
                our discretion, with or without notice, if these Terms are violated.
            </p>

            <h2>10. Changes to These Terms</h2>
            <p>
                We may update these Terms & Conditions from time to time. Continued use
                of the platform after changes constitutes acceptance of the updated
                terms.
            </p>

            <h2>11. Contact</h2>
            <p>
                For questions regarding these Terms, please contact us at a dedicated
                support email, which will be provided in the future.
            </p>
        </div>
    );
};

export default TermsConditions;